import CLangInactive from './c-lang-inactive';

export default CLangInactive;
